export { Flex, type FlexOwnProps, type FlexProps } from './flex/Flex.js';
export { Grid, type GridOwnProps, type GridProps } from './grid/Grid.js';
export { Divider } from './divider/Divider.js';
export type { DividerProps } from './divider/Divider.js';
export {
  Container,
  useContainerColoring as _useContainerColoring,
  type ContainerColoring as _ContainerColoring,
} from './container/Container.js';
export type {
  ContainerOwnProps,
  ContainerProps,
} from './container/Container.js';
export type { LayoutSizeCSS } from './types/layout.types.js';
export { Surface } from './surface/Surface.js';
export type { SurfaceOwnProps, SurfaceProps } from './surface/surface-types.js';
export { surfaceBorderRadius as _surfaceBorderRadius } from './surface/variables.sty.js';
export { useBreakpoint } from './hooks/useBreakpoint.js';
export { AppHeader } from './app-header/AppHeader.js';
export type { AppHeaderProps } from './app-header/AppHeader.js';
export type {
  AppHeaderActionButtonOwnProps,
  AppHeaderActionButtonProps,
} from './app-header/ActionButton.js';
export type { AppHeaderActionItemsProps } from './app-header/ActionItems.js';
export type { ActionItemGroupProps } from './app-header/ActionItemGroup.js';
export { HelpMenu } from './help-menu/HelpMenu.js';
export type {
  HelpMenuProps,
  HelpMenuButtonEntry,
  HelpMenuLinkEntry,
  HelpMenuChildrenEntry,
  HelpMenuCustomLinkEntry,
  HelpMenuCustomItemEntry,
  HelpMenuDefault,
} from './help-menu/HelpMenu.js';
export type {
  AppHeaderNavigationProps,
  AppHeaderNavigationItemOwnProps,
  AppHeaderNavigationItemProps,
  // exported with alternate name for backwards compatibility
  AppHeaderNavigationProps as AppHeaderNavItemsProps,
} from './app-header/Navigation.js';
export type { AppIconProps } from './app-header/app-icon/AppIcon.js';
export { Logo, Logo as AppNavLink } from './app-header/Logo.js';
export type {
  AppHeaderLogoProps,
  AppHeaderLogoOwnProps,
  // exported with alternate name for backwards compatibility
  AppHeaderLogoProps as AppNavLinkProps,
  AppHeaderLogoOwnProps as AppNavLinkOwnProps,
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  AppNavLinkInternalOwnProps, // exported for backwards compatibility
} from './app-header/Logo.js';
export type {
  ActionButtonOwnProps,
  ActionButtonProps,
} from './app-header/action-group/ActionButton.js';
export { ActionGroup as _ActionGroup } from './app-header/action-group/ActionGroup.js';
export type { ActionGroupProps as _ActionGroupProps } from './app-header/action-group/ActionGroup.js';
export type {
  NavItemProps,
  NavItemOwnProps,
} from './app-header/action-group/NavItem.js';
export type { GroupProps } from './app-header/action-group/Group.js';

export type {
  ControlledDetailViewProps,
  DetailViewOwnProps,
  DetailViewProps,
  UncontrolledDetailViewProps,
} from './page/DetailView.js';
export type { HeaderProps } from './page/Header.js';
export type { MainProps } from './page/Main.js';
export { Page } from './page/Page.js';
export type { PageProps } from './page/Page.js';
export { panelSizeUnits } from './page/panel-types.js';
export type {
  PanelSize,
  PanelSizeUnit,
  Direction as _Direction,
} from './page/panel-types.js';
export type { PanelControlButtonProps } from './page/PanelControlButton.js';
export type {
  ControlledSidebarProps,
  SidebarOwnProps,
  SidebarProps,
  UncontrolledSidebarProps,
} from './page/Sidebar.js';
export { pagePanels } from './page/page-types.js';
export type {
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  DismissiblePagePanels,
  PagePanelSizes,
  PanelName,
  /** @deprecated Use `PanelName` instead. */
  PanelName as PagePanels,
  ControlledPagePanelProps,
  // eslint-disable-next-line @typescript-eslint/no-deprecated
  PagePanelProps,
  UncontrolledPagePanelProps,
} from './page/page-types.js';

export type { TitleBarActionProps } from './title-bar/Action.js';
export type { TitleBarNavigationProps } from './title-bar/Navigation.js';
export type { TitleBarPrefixProps } from './title-bar/Prefix.js';
export type { TitleBarSubtitleProps } from './title-bar/Subtitle.js';
export type { TitleBarSuffixProps } from './title-bar/Suffix.js';
export type { TitleBarTitleProps } from './title-bar/Title.js';
export { TitleBar } from './title-bar/TitleBar.js';
export type { TitleBarProps } from './title-bar/TitleBar.js';

export { InputGroup, type InputGroupProps } from './input-group/InputGroup.js';
export { inputGroupClassName } from './input-group/InputGroup.sty.js';

export { SplitLayout as _SplitLayout } from './split-layout/SplitLayout.js';
export type { SplitLayoutProps as _SplitLayoutProps } from './split-layout/SplitLayout.js';
export type { ResizeHandleProps as _SplitLayoutResizeHandleProps } from './split-layout/slots.js';
export { PageLayout } from './page-layout/PageLayout.js';
export type { ResizablePanelProps } from './split-layout/slots.js';
export type { PanelWidth } from './split-layout/width-utils.js';
export type { PageLayoutProps } from './page-layout/PageLayout.js';
export type { CollapsiblePanel } from './page-layout/shared/collapsible.js';
export type { HeaderProps as PageLayoutHeaderProps } from './page-layout/shared/portal-slots.js';
export type { SidebarProps as PageLayoutSidebarProps } from './page-layout/sidebar-layout/slots.js';
export type { DetailsProps as PageLayoutDetailsProps } from './page-layout/details-layout/slots.js';
export type { ContentProps as PageLayoutContentProps } from './split-layout/slots.js';
export type { LayoutMode as PageLayoutDetailsLayoutMode } from './page-layout/details-layout/DetailsLayoutContext.js';
export type { DetailsControlBarProps as PageLayoutDetailsControlBarProps } from './page-layout/details-layout/slots.js';
